module.exports = __webpack_public_path__ + "img/menu-icon-etabs.882226db.svg";